import React from "react";
import Pen from "features/../../../shared/assets/pen.svg";
import Save from "features/../../../shared/assets/save.svg";
import {
  getRateTable,
  updateRateTable,
} from "features/../../../shared/features/Settings/Rates/actions.js";
import { Button } from "semantic-ui-react";
import { Form, FormBuilder } from "@redriver/cinnamon";
import { IconButton } from "features/../../../shared/components/buttons";
import { PermissionCheck } from "features/../../../shared/components/auth";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import { FormattedNumericInput } from "features/../../../shared/components/forms";

const getLabel = (name, required) => {
  return (
    <div className="default-grid-field-label-container">
      <div className="defaults-grid-title">
        <p>{name}</p>
        {required && <span className="required-star">*</span>}
      </div>
    </div>
  );
};

const RateTableDefaultsForm = ({ rateGroupId, filters }) => {
  const params = {
    rateGroupId: rateGroupId,
    funderType: filters.funderType,
    financeType: filters.financeType,
    paymentMethod: filters.paymentMethod,
    calcTableType: filters.calcTableType,
  };

  return (
    <FormBuilder
      initialReadOnly
      loadAction={getRateTable}
      loadParams={params}
      submitAction={updateRateTable}
      submitParams={params}
      renderLoading={false}
      renderSubmitting={false}
      renderForm={(formProps, state, events) => {
        return (
          <div className="rate-table-defaults-fields">
            <Form {...formProps}>
              <FormattedNumericInput
                field="defaultProdCapCost"
                label={getLabel("Default Product Capital Cost")}
                placeholder="Default Product Capital Cost..."
                subLabel={process.env.MAJOR_CURRENCY}
                subLabelPosition="left"
                showSubLabelInReadOnly
                decimalPlaces={2}
                minValue={0}
                width="initial"
              />
              <FormattedNumericInput
                field="defaultRrp"
                label={getLabel("Default RRP")}
                placeholder="Default RRP..."
                subLabel={process.env.MAJOR_CURRENCY}
                subLabelPosition="left"
                showSubLabelInReadOnly
                decimalPlaces={2}
                minValue={0}
                width="initial"
              />
              <FormattedNumericInput
                field="rrpPercentage"
                label={getLabel("RRP Allowance", true)}
                placeholder="RRP Allowance..."
                required
                decimalPlaces={2}
                minValue={0}
                maxValue={999.0}
                width="initial"
              />
              <PermissionCheck target={Targets.Rates} action={Actions.Edit}>
                <div className="rate-table-defaults-actions">
                  <Button
                    primary
                    className="cancel-title-action"
                    content="Cancel"
                    onClick={events.onReset}
                    style={
                      state.readOnly ? { visibility: "hidden" } : undefined
                    }
                  />
                  <IconButton
                    primary
                    icon={state.readOnly ? Pen : Save}
                    content={state.readOnly ? "Edit" : "Save"}
                    onClick={async () => {
                      if (state.readOnly) {
                        await events.onRefresh();
                        events.onToggleReadOnly();
                      } else {
                        events.onSubmit({ reset: ["readOnly"] });
                      }
                    }}
                    className={!state.readOnly ? "positive-title-action" : null}
                    loading={state.loading || state.submitting}
                    disabled={state.loading || state.submitting}
                  />
                </div>
              </PermissionCheck>
            </Form>
          </div>
        );
      }}
    />
  );
};

export default RateTableDefaultsForm;
